import { useCallback, useEffect, useRef, useState } from "react";

import api from "@helpers/api";
import { adaptMyEnrollmentListItem } from "../helpers/apiAdapters";

/**
 * Creator's subscribed mentorings (§6.11 list). Owns the data + loading state,
 * fetches once on mount, and exposes refresh() via a reloadToken. A request
 * stale-guard drops late responses if a refresh races a previous fetch.
 */
export default function useMyMentorings() {
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reloadToken, setReloadToken] = useState(0);

  const requestRef = useRef(0);

  useEffect(() => {
    const requestId = ++requestRef.current;
    setLoading(true);

    (async () => {
      const res = await api.get("mentoring/my-enrollments", { per_page: 50 });
      if (requestId !== requestRef.current) return;

      const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
      setEnrollments(rows.map(adaptMyEnrollmentListItem));
      setLoading(false);
    })();
  }, [reloadToken]);

  const refresh = useCallback(() => setReloadToken((t) => t + 1), []);

  return { enrollments, loading, refresh };
}
